import { useQuery } from 'hooks/useCustomQuery';
import { getVgs } from 'API/VisibilityGroups/getVisibilityGroups';
import { useSelector } from 'react-redux';

export const useGetVisibilityGroups = (adminID) => {
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });

    return useQuery({
        queryKey: ['visibilityGroups', adminID],
        queryFn: async () => {
            try {
                const res = await getVgs();
                return res.data;
            } catch (error) {
                console.error('Failed to fetch visibility groups:', error);
                throw error;
            }
        },
        enabled: Boolean(currentCompany),
        refetchOnWindowFocus: false,
        staleTime: 0,
    });
};

export default useGetVisibilityGroups;
